<template>
  <div class="top-bar">
    <img class="logo"
         src="../../../assets/mobile/imgs/index/zjdlogo.png" />
    <div class="right-con">
      <van-popover v-if="!enLang" v-model="showPopover"
                     trigger="click"
                     :actions="actions"
                     @select="changeLangEvent">
          <template #reference>
            <div class="con_1">
              <span>
                {{languageText}}
              </span>
              <img class="arrow"
                   src="../../../assets/mobile/imgs/index/arrow_down.png" />

            </div>
          </template>
        </van-popover>
      <img class="menu"
           src="../../../assets/mobile/imgs/index/menu.png"
           @click="menuClick"/>
    </div>
    <van-popup class="popup"
               v-model="show"
               position="right"
               duration = '0'
               round
               closeable
               close-icon-position="top-right"
               :style="{ height: '100%' }">
      <div class="box" :class="$i18n.locale == 'en-us' ? 'pl60' : 'pl87'">
        <ul class="menu-list">
          <li v-for="(item,index) in menuList"
              :key="index"
              :style="{marginBottom: item.type == '1' ? '29px' : '13px'}"
              :class="item.type == '1' ? 'type1' : item.type == '2' ? 'type2' : 'type3'">
            <span v-if="item.show"
                  :class="currentMenuId == item.id ? 'active': ''"
                  @click="goPage(item)">{{$i18n.locale == 'en-us' ? item.ename : item.name}}</span>
            <span class="right" v-if="item.show && item.hasChildren" @click="showChild(item)"></span>
          </li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { menuList } from './menu.js'
export default {
  props: {
    showHeader: {
      type: Boolean,
    }
  },
  data() {
    return {
      show: false,
      menuList,
      currentMenuId: '1',
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      actions: [{ text: '中文 CN' }, { text: '英文 EN' }],
      languageText: "中文",
      isYtEnv: false,
    }
  },
  computed: {
    enLang() {
      // 如果值为en 展示逻辑变更，不显示中英切换
      const flag = sessionStorage.getItem('lang') === 'en'
      return flag
    }
  },
  created() {
    if(this.enLang) {
      this.menuList = this.menuList.filter(item => !item.langShow)
    }
  },
  mounted() {
    this.languageText = this.$i18n.locale === "zh-cn" ? '中文' : 'English'
    //判断域名，是否是
    const currentHost = window.location.host;
    if (currentHost === "yutai365.com") {
      this.isYtEnv = true;
    }
  },
  watch: {
    enLang: {
      handler(val) {
        if(val && localStorage.getItem("locale") !== "en-us") {
          this.changeLangEvent({text: '英文 EN'})
        }
      },
      immediate: true,
    }
  },
  methods: {
    changeLangEvent(action) {
      let language = action.text == '英文 EN' ? 'en-us' : 'zh-cn'
      if (localStorage.getItem("locale") != language) {
        this.$router.go(0);
      }
      if (language === "en-us") {
        localStorage.setItem("locale", "en-us");
        this.$i18n.locale = localStorage.getItem("locale"); //关键语句
        this.languageText = "English";
      } else {
        localStorage.setItem("locale", "zh-cn");
        this.$i18n.locale = localStorage.getItem("locale"); //关键语句
        this.languageText = "中文";
      }
    },
    menuClick() {
      this.show = true
    },
    goPage(item) {
      if(item.path) {
        this.show = false
        if(item.path.indexOf('http') > -1) {
          window.location.href = item.path
        } else {
          this.$router.push(item.path)
          // if (item.path.indexOf("/productDetails/") > -1) {
          //   // 产品类，跳转到宇泰域名下
          //   if(process.env.NODE_ENV === 'production') {
          //     window.location.href = "https://yutai365.com/middle" + item.path;
          //   } else {
          //     this.$router.push(item.path)
          //   }
          // } else {
          //   if(this.isYtEnv) {
          //     window.location.href = "https://www.medilink-global.com.cn/MediLink" + item.path;
          //   } else {
          //     this.$router.push(item.path)
          //   }
          // }
        }
        return
      }
      this.showChild(item)
    },
    showChild(item) {
      this.currentMenuId = item.id
      if (item.hasChildren) {
        this.menuList.forEach(e => {
          if (item.id == e.parentId) {
            e.show = !e.show
            if(e.hasChildren) {
              this.showChild(e)
            }
          }
        });
      }
    }
  }
}
</script>
<style lang="less">
.top-bar {
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100vw;
  height: 42px;
  padding: 14px 15px 10px;
  color: #232323;
  z-index: 1;
  background: #fff;
  .right-con {
    display: flex;
    align-items: center;
  }
  .logo {
    width: 63px;
    height: 18px;
  }
  .arrow {
    width: 4px;
    height: 3px;
    margin-left: 4px;
  }
  .con_2 {
    margin-left: 11px;
  }
  .menu {
    margin-left: 11px;
    width: 23px;
    height: 22px;
  }
  .popup {
    
    .box {
      padding: 112px 0 0 87px;
      height: 100%;
      width: 275px;
      .menu-list {
        .type1 {
          font-size: 17px;
          font-weight: 500;
          color: #000000;
        }
        .type2 {
          font-size: 14px;
          font-weight: 500;
          color: #383838;
        }
        .type3 {
          font-size: 14px;
          font-weight: 400;
          color: #383838;
        }
        .right {
          display: inline-block;
    vertical-align: middle;
    margin: 0 10px;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
          border-left: 4px solid #000;
          border-right: 4px solid transparent;
        }
        .down {
          display: inline-block;
    vertical-align: middle;
    margin: 0 10px;
          border-top: 4px solid #000;
          border-bottom: 4px solid transparent;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
        }
        .active {
          color: #ff3600;
        }
      }
    }
    .pl60 {
      padding-left: 60px;
    }
    .pl87 {
      padding-left: 60px;
    }
  }
}
</style>
